import React, { FormEvent, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../shared/services/auth-context/auth-context";
import luxoraLogo from "../../../../assets/luxora.png";
import {SERVER_URL, LOGIN_API_PATH} from "../../../../global_vars";
import DOMPurify from "dompurify";

interface LoginState {
    user_id: string;
    password: string;
    msg: string;
}


interface LoginResponse {
    code: number;
    // used during success
    access_token: string;
    refresh_token: string;
    // used during failure
    msg: string;
}

interface NavigationHelper {
    from: string;
}



function Login() {

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [state, setState] = useState<LoginState>({
       user_id: "",
       password: "",
       msg: "",
   });


    // Event handlers
    const handleUserNameChange = (event: React.FormEvent<HTMLInputElement>) => {
        setState({
            ...state,
            user_id: DOMPurify.sanitize(event.currentTarget.value),
        });
    }

    const handlePasswordChange = (event: React.FormEvent<HTMLInputElement>) => {
        setState({
            ...state,
            password: DOMPurify.sanitize(event.currentTarget.value),
        });
    }

    const handleLogin = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        fetch(SERVER_URL+LOGIN_API_PATH, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                user_id: state.user_id,
                password: state.password,
            })
        }).then((resp) => {
            return resp.json();
        }).then((data: LoginResponse) => {
            if(data.access_token !== "" && data.access_token !== null && data.access_token !== undefined) {
                console.log("Received: 200");
                login(state.user_id, data.access_token, data.refresh_token);
                const locationHelper: NavigationHelper = location.state
                navigate(locationHelper.from, {replace: true});
            } else {
                console.log("Received other than 200");
                console.log(data);
                setState({
                    ...state,
                    msg: data.msg,
                })
            }
        }).catch((error) => {
            console.log("Error while logging in: ", error);
            setState({
                ...state,
                msg: "Unknown error while logging in. Contact Administrator",
            })
        });
    }


    return (
        <div>
            <div className="container h-100">
                <div className="row justify-content-sm-center h-100">
                    <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-7 col-sm-9">
                        <div className="text-center my-5">
                            <img src={luxoraLogo} alt="Luxora Logo" className="logo" />
                        </div>

                        <div className="card shadow-lg">
                            <div className="card-body p-5">
                                <h1 className="fs-4 card-title fw-bold mb-4" style={{ color: '#001f3f' }}>Login</h1>
                                <div>
                                    <p className="login_err_msg"> {state.msg} </p>
                                </div>
                                <form method="POST" onSubmit={handleLogin} className="needs-validation">
                                    <div className="mb-3">
                                        <label className="mb-2 text-muted">E-Mail Address</label>
                                        <input type="email" className="form-control" placeholder="Email" onChange={handleUserNameChange} value={state.user_id} name="username" id="username" required />

                                        <div className="invalid-feedback">
                                            Email is invalid
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <div className="mb-2 w-100">
                                            <label className="text-muted">Password</label>
                                            <a href="/password/forgot" className="float-end">
                                                Forgot Password?
                                            </a>
                                        </div>
                                        <input type="password" className="form-control" placeholder="Password" onChange={handlePasswordChange} value={state.password} name="password" id="password" required />

                                        <div className="invalid-feedback">
                                            Password is required
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center">
                                        <button type="submit" className="btn btn-deepNavyBlue ms-auto" >
                                            Login
                                        </button>
                                    </div>

                                </form>
                            </div>
                            <div className="card-footer py-3 border-0">
                                <div className="text-center">
                                    Don't have an account? <a href="/signup" className="text-dark fw-bold">Sign Up</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}


export default Login;